import { FC, useCallback } from 'react';
import styled, { css } from 'styled-components';
import { IconProps } from '../icon/createIconComponent';
import { Button, ButtonColor } from '../input/Button';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

const Container = styled(Button)
    .withConfig({ displayName: 'Container' })
    .attrs((props) => ({
        padding: '12px 16px',
        width: '100%',
        height: 'auto',
        textTransform: 'none',
        textAlign: 'left',
        isHoverEnabled: false,
        onClick: props.onClick,
    }))`
    border-radius: 16px;
    box-shadow: 0px 0px 4px 0px var(--control-primary-blur-background);
    ${(props) =>
        !props.color &&
        css`
            background-color: var(--background-primary);
        `}
`;

interface ToastProps {
    message: string;
    subtitle?: string;
    onClick?: VoidFunction;
    onRemove?: VoidFunction;
    actionText?: string;
    icon?: FC<IconProps>;
    color?: ButtonColor;
}

export const Toast: FC<ToastProps> = ({
    message,
    subtitle,
    onClick: onClickBase,
    actionText,
    onRemove,
    icon: IconComponent,
    color,
}) => {
    const onClick = useCallback(() => {
        onClickBase?.();
        onRemove?.();
    }, [onClickBase, onRemove]);

    return (
        <Container onClick={onClick} color={color}>
            <Flex
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                spacing={2}
            >
                {IconComponent ? <IconComponent size={20} fill="var(--color-primary)" /> : null}
                <Flex direction="column" mr="auto">
                    <Typography variant="body">{message}</Typography>
                    {subtitle ? (
                        <Typography variant="caption" color="var(--color-secondary)">
                            {subtitle}
                        </Typography>
                    ) : null}
                </Flex>
                {actionText ? (
                    <Typography textTransform="uppercase" variant="caption" weight="bold">
                        {actionText}
                    </Typography>
                ) : null}
            </Flex>
        </Container>
    );
};
